import * as React from "react"

const Close = (props) => (
  <svg
    width={40}
    height={40}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>btnClose</title>
    <defs>
      <path
        d="M20 40c6.535 0 12.339-3.135 15.988-7.982A19.912 19.912 0 0 0 40 20C40 8.954 31.046 0 20 0S0 8.954 0 20s8.954 20 20 20Z"
        id="a"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g opacity={0.5}>
        <use fill="#222526" xlinkHref="#a" />
        <path
          stroke="#222526"
          strokeWidth={2}
          d="M20 39c6.047 0 11.62-2.843 15.19-7.584A18.909 18.909 0 0 0 39 20C39 9.507 30.493 1 20 1S1 9.507 1 20s8.507 19 19 19Z"
        />
      </g>
      <path
        fill="#FFF"
        d="M27 14.4 25.6 13 20 18.6 14.4 13 13 14.4l5.6 5.6-5.6 5.6 1.4 1.4 5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6z"
      />
    </g>
  </svg>
)

export default Close
